import React from 'react';
import Aux from '../../hoc/Aux';
import useWindowDimensions from '../../hooks/useWindowDimensions';

const wizardButton = (props) => {

  const { height } = useWindowDimensions();

  const divider = (indexValue, dividerEnabled) => {
    if (indexValue % 2 && dividerEnabled === true) {
      return <div className="w-100"></div>
    }
  }

  const colWidth = (dividerEnabled) => {
    return (dividerEnabled === true)? "col-6 col-md-5" : "col-12 col-md-11"
  }

  const btnStyle = (style) => {
    return (style !== undefined)? style : ""
  }

  // Buttonhöhe auf z.b iphone6 und einer bestimmten Anzahl von Buttons verringern
  // damit der Weiter-Button noch zu sehen ist

  const cssButton = () => {

   if (height < 600 ) {
     return {
       height: "45px"
     }
   }
  }


  return (
    <Aux>
    <div className={colWidth(props.dividerEnabled)}>
      <button type="button" onClick={ (e) => props.onClick(props.value) } style={cssButton()} className={"btn btn-light wizzard-btn " + btnStyle(props.btnStyle)}>{props.title}</button>
    </div>
    { divider(props.indexValue, props.dividerEnabled) }
    </Aux>
  );

};

export default wizardButton;



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardButton.js